var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import qs from 'qs';
import { useTheme } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { deliveryRequest as api } from '../../api/';
import { useDeliveryRequestColumns } from '../../hooks/useColumns';
import { useRequest } from '../../hooks/requestHook';
import useFetch from '../../hooks/useFetch';
import MaterialTable from '../MaterialTable';
import { decamelize } from '../../utils/camelize';
import PageLayout from '../atoms/PageLayout';
var TableWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &.sp table {\n    .MuiSvgIcon-root {\n      font-size: 0.8em;\n    }\n\n    th,\n    td {\n      padding: 0 4px;\n    }\n\n    input {\n      font-size: 0.8em;\n      min-width: 50px;\n    }\n\n    .MuiSelect-root {\n      font-size: 0.8em;\n      min-width: 30px;\n      padding-right: 5px;\n    }\n  }\n"], ["\n  &.sp table {\n    .MuiSvgIcon-root {\n      font-size: 0.8em;\n    }\n\n    th,\n    td {\n      padding: 0 4px;\n    }\n\n    input {\n      font-size: 0.8em;\n      min-width: 50px;\n    }\n\n    .MuiSelect-root {\n      font-size: 0.8em;\n      min-width: 30px;\n      padding-right: 5px;\n    }\n  }\n"])));
var RoasterDeliveryRequestsPage = function () {
    var t = useTranslation().t;
    var location = useLocation();
    var DeliveryRequestColumns = useDeliveryRequestColumns();
    var getAll = useRequest(api.getAll);
    var theme = useTheme();
    var mode = useMediaQuery(theme.breakpoints.down('md')) ? 'sp' : 'pc';
    var urlQuery = qs.parse(location.search.slice(1));
    var initialPage = parseInt((urlQuery.page || '')) || 0;
    var pageSize = parseInt((urlQuery.pageSize || '')) || 25;
    var defaultFilter = React.useCallback(function (field) {
        var filters = urlQuery.filters || {};
        return filters[field];
    }, [urlQuery]);
    var defaultSort = React.useCallback(function (field) {
        var orderBy = urlQuery.orderBy;
        var orderDirection = urlQuery.orderDirection;
        var direction = 'asc';
        if (['asc', 'desc'].includes(orderDirection !== null && orderDirection !== void 0 ? orderDirection : ''))
            direction = orderDirection;
        if (field == orderBy)
            return direction;
    }, [urlQuery]);
    var columns = React.useMemo(function () { return [
        __assign(__assign({}, DeliveryRequestColumns.id), { filtering: false, filterCellStyle: {
                minWidth: 0,
            }, defaultSort: defaultSort('id') }),
        __assign(__assign({}, DeliveryRequestColumns.deliveryItems), { filtering: false, sorting: false }),
        __assign(__assign({}, DeliveryRequestColumns.requestDate), { defaultSort: defaultSort('requestDate') }),
        __assign(__assign({}, DeliveryRequestColumns.status), { defaultSort: defaultSort('status'), defaultFilter: defaultFilter('status') }),
        __assign(__assign({}, DeliveryRequestColumns.storeName), { filtering: false, sorting: false }),
        __assign(__assign({}, DeliveryRequestColumns.nameWithKana), { filtering: false, sorting: false }),
        __assign(__assign({}, DeliveryRequestColumns.countryCallingCode), { filtering: false, sorting: false }),
        __assign(__assign({}, DeliveryRequestColumns.phone), { filtering: false, sorting: false }),
        __assign(__assign({}, DeliveryRequestColumns.postalCode), { filtering: false, sorting: false }),
        __assign(__assign({}, DeliveryRequestColumns.fullAddress), { filtering: false, sorting: false }),
        __assign(__assign({}, DeliveryRequestColumns.createdAt), { filtering: false }),
    ]; }, [defaultFilter, DeliveryRequestColumns, defaultSort]);
    var buildFilterParams = React.useCallback(function (query) {
        var q = {};
        query.filters.forEach(function (filter) {
            switch (filter.column.field) {
                case 'status':
                    q.with_status = filter.value;
                    break;
                default:
                    if (filter.column.field) {
                        var field = filter.column.field
                            .split('.')
                            .map(function (e) { return decamelize(e); })
                            .join('_');
                        q["".concat(field, "_cont")] = filter.value;
                    }
                    break;
            }
        });
        return q;
    }, []);
    var buildOrder = React.useCallback(function (order) { return decamelize(order); }, []);
    var fetchDeliveryRequests = useFetch({
        buildFilterParams: buildFilterParams,
        api: getAll,
        buildOrder: buildOrder,
    });
    return (React.createElement(PageLayout, { title: t('pages.deliveryRequests.title') },
        React.createElement(TableWrapper, { className: mode },
            React.createElement(MaterialTable, { model: "deliveryRequest", columns: columns, data: fetchDeliveryRequests, detailPath: function (_a) {
                    var id = _a.id;
                    return "/roaster/delivery_requests/".concat(id);
                }, options: {
                    filtering: true,
                    filterCellStyle: {
                        minWidth: 100,
                    },
                    paging: true,
                    initialPage: initialPage,
                    pageSize: pageSize,
                } }))));
};
export default RoasterDeliveryRequestsPage;
var templateObject_1;
